/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

const { listTimeZones } = require('timezone-support')

const styles = theme => ({

})

class FlexTZPicker extends Component {
    state = {
        value: null,
        error : false,
        loading : false,
        helper_text : "Start typing the canonical time zone name or choose from the list"
    }

    getOptions = () => {
        let options = listTimeZones()
        return options
    }

    handleChange = (value) => {
        this.setState({...this.state, value: value}, () => console.log("State Value: ", this.state))
    }

    validateAndPush = () => {
        this.setState({...this.state, error : false} , () => {
            this.props.update_value(this.props.instance.id, 'text', this.state.value)
        })
    }

    render() { 
        const { classes } = this.props
        return (
            <Autocomplete
                style = {{width : '100%'}}
                value = {this.state.value}
                onChange = {(event, newValue) => this.handleChange(newValue)}
                onBlur = {this.validateAndPush}
                options={this.getOptions()}
                getOptionLabel={(option) => option}
                disabled = {this.props.disabled}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        margin = 'dense'
                        label= {this.props.instance.name}
                        placeholder= "Canonical Time Zone Name"
                        helperText = {this.state.helper_text}
                        error = {this.state.error}
                    />
                )}
            />
        );
    }
}
 
export default withStyles(styles)(FlexTZPicker);